import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BusinessChange from './BusinessChange';
import {
  getAddressBusiness, setAddressBusiness
} from "services/redux/sales/corporate/pocDetails/action";

const mapStateToProps = (state) => ({
  businessDetails: state.pocTypesReducer.businessDetail
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAddressBusiness,
      setAddressBusiness,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BusinessChange);